import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';

const { colors, radius, sizes, fonts, fontSize } = redesignTheme;

export const useSignupFormStyles = makeStyles((theme: Theme) => ({
  materialPhoneInput: {
    border: `1px solid ${colors.border}`,
    borderRadius: radius.sm,
    height: sizes.inputHeight,
    backgroundColor: colors.white,
  },
  helperText: {
    fontFamily: fonts.opensans,
    fontSize: fontSize.sm,
    color: colors.textBody,
    margin: 0,
  },
  checkboxRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 12,
    width: '100%',
  },
  checkbox: {
    padding: 0,
    '&.Mui-checked': {
      color: `${theme.palette.primary.main} !important`,
    },
  },
  checkboxLabel: {
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    color: colors.text,
    lineHeight: 1.5,
    margin: 0,
  },
}));
